// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__1XGpJ","spin":"Spinner_spin__1N6Nr"};